import { useMemo } from "react";
import stringify from "fast-json-stable-stringify";

/**
 * Sometimes we only want to re-run hooks if some args, data meaningfully change,
 * while callers may construct the said object on the fly which means its identity
 * may change with every render. We use `stable-hash` to compare the value of `args`
 * and only re-run the hooks if data changes.
 */
export const useStableObject = <TData,>(_data: TData): TData => {
  // We only want to re-run the hook below if the `questions` meaningfully changes.
  const dataHash = stringify(_data);
  const data = useMemo(
    () => _data,
    // eslint-disable-next-line
    [dataHash],
  );
  return data;
};
